import React, { createContext, useState, useContext, useEffect } from 'react';
import storage from '../Storage';

const GlobalContext = createContext<any>({
  isLoading: false,
});

export function useGlobal() {
  return useContext(GlobalContext);
}

export function GlobalProvider({ children }: any) {
  const [isLoading, setIsLoading] = useState(false);
  const [contextLoader, setContextLoader] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const localTheme = localStorage.getItem('theme');
    return localTheme === 'dark' ? true : false;
  });

  useEffect(() => {
    if (isDarkMode) {
      window.document.body.classList.add('dark');
    } else {
      window.document.body.classList.remove('dark');
    }
  }, [isDarkMode]);

  const setDarkMode = (isDarkTheme: boolean) => {
    setIsDarkMode(isDarkTheme);
    localStorage.setItem('theme', isDarkTheme ? 'dark' : 'light');
  };

  return (
    <GlobalContext.Provider
      value={{ isLoading, setIsLoading, isDarkMode, setDarkMode, contextLoader, setContextLoader }}
    >
      {children}
    </GlobalContext.Provider>
  );
}
